'use client';

import { Button } from '@/components/ui/Button';
import Link from 'next/link';

export const CTASection = ({ 
  title = "Ready to Transform Your Supply Chain?",
  description = "Join leading organizations worldwide using our platform to optimize their supply chain operations."
}) => (
  <div className="text-center bg-orange-50 rounded-2xl p-8 md:p-12">
    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
      {title}
    </h2>
    <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
      {description}
    </p>
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Button size="lg"
className="bg-orange-600 hover:bg-orange-700">
        <Link href={`/dashboard/${process.env.NEXT_PUBLIC_DEMO_VULCAN_ID}`}>See It In Action</Link>
      </Button>
      <Button 
        variant="outline"
        size="lg"
        className="bg-emerald-600 hover:bg-emerald-700 text-white"
      >
        <Link href="/contact">Contact Sales</Link>
      </Button>
    </div>
  </div>
);